import { TemplatesListContainer } from "../containers/TemplatesListContainer";

export const TemplatesPage = () => (
    <TemplatesListContainer/>
)
